import { setRangeMax } from './helpers';

export const setTotalAreaMax = setRangeMax('total_area');
